export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_q02_b.afe18c6f.png";